export default function WhatIsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
          <div className="order-2 lg:order-1">
            <span className="inline-block px-4 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-label font-medium mb-4">
              Getting Started
            </span>
            <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-900 mb-4">
              What Is Sugargoo Spreadsheet?
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-5">
              A <strong>Sugargoo Spreadsheet</strong> is a curated, organized database of product finds shared by the Sugargoo shopping community. Instead of wasting hours randomly browsing through thousands of unorganized listings, the spreadsheet gives you instant access to trending products, verified sellers, and quality finds &mdash; all neatly categorized and regularly updated.
            </p>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6">
              Whether you are a beginner exploring Sugargoo for the first time or an experienced shopper looking to streamline your product research, a well-maintained Sugargoo Spreadsheet saves you time, helps you discover hidden gems, and makes the entire shopping experience significantly more efficient.
            </p>

            <div className="overflow-hidden rounded-xl border border-background-200/70 mb-6">
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-background-100">
                    <th className="text-left px-4 py-3 font-label font-semibold text-foreground-800 text-xs uppercase tracking-wider">
                      Searching Method
                    </th>
                    <th className="text-left px-4 py-3 font-label font-semibold text-foreground-800 text-xs uppercase tracking-wider">
                      Time Required
                    </th>
                    <th className="text-left px-4 py-3 font-label font-semibold text-foreground-800 text-xs uppercase tracking-wider">
                      Result Quality
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-t border-background-200/50">
                    <td className="px-4 py-3 text-foreground-600">Random Browsing</td>
                    <td className="px-4 py-3 text-foreground-500">Hours of searching</td>
                    <td className="px-4 py-3 text-foreground-500">Low efficiency, hit or miss</td>
                  </tr>
                  <tr className="border-t border-background-200/50">
                    <td className="px-4 py-3 text-primary-700 font-medium">Sugargoo Spreadsheet</td>
                    <td className="px-4 py-3 text-primary-700 font-medium">Minutes to discover</td>
                    <td className="px-4 py-3 text-primary-700 font-medium">Organized, curated finds</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white text-sm font-label font-semibold hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
            >
              Buy It Now
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>

          <div className="order-1 lg:order-2">
            <div className="aspect-[4/5] w-full rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20modern%20desk%20setup%20with%20macbook%20showing%20organized%20database%20interface%2C%20fashion%20catalog%20and%20product%20photos%20beside%20it%2C%20warm%20natural%20light%20from%20window%2C%20cream%20walls%2C%20aesthetic%20workspace%20photography%20with%20soft%20shadows%20and%20minimal%20composition&width=600&height=750&seq=what-is-section-2026&orientation=portrait&nocache=true"
                alt="What is Sugargoo Spreadsheet - workspace with organized database"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}